import { render, staticRenderFns } from "./CustomOjtMaExport.vue?vue&type=template&id=58a1d1e8"
import script from "./CustomOjtMaExport.vue?vue&type=script&lang=js"
export * from "./CustomOjtMaExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports